/**
 * LinkEditPopup
 * Generic popup component for editing/deleting links in editor
 */
import CloseIcon from '@assets/images/common/icon/close.svg';
import Button from '@src/ui/elements/button/Button';
import React from 'react';
import { createPortal } from 'react-dom';

import type { LinkUrlParams } from '../types';

interface LinkEditPopupProps {
  isOpen: boolean;
  onClose: () => void;
  onDelete: () => void;
  onEdit: () => void;
  value: LinkUrlParams;
}

export const LinkEditPopup: React.FC<LinkEditPopupProps> = ({
  isOpen,
  onClose,
  onDelete,
  onEdit,
  value,
}) => {
  return createPortal(
    <>
      {isOpen && (
        <div className='fixed left-0 top-0 z-[9999] size-full'>
          <div
            className='fixed inset-0 z-40 bg-black opacity-30'
            onClick={onClose}
          />
          <div className='absolute left-1/2 top-1/2 z-50 w-[392px] -translate-x-1/2 -translate-y-1/2 rounded-md border border-gray-200 bg-white p-6 lg:w-[95%]'>
            <p className='mb-2 line-clamp-1 break-all font-medium'>{value.text}</p>
            <div className='flex'>
              <a
                className='line-clamp-6 max-h-[144px] overflow-y-auto break-all text-primary-500 underline'
                href={value.url}
                target='_blank'
                rel='noopener noreferrer'
              >
                {value.url}
              </a>
            </div>
            <div className='mt-5 flex items-center justify-center gap-2'>
              <div className='w-[120px]'>
                <Button
                  size='s'
                  variant='secondary'
                  fullRounded
                  fullWidth
                  outline
                  onClick={onDelete}
                >
                  削除
                </Button>
              </div>
              <div className='w-[120px]'>
                <Button
                  size='s'
                  variant='tertiary'
                  fullRounded
                  fullWidth
                  outline
                  onClick={onEdit}
                >
                  編集
                </Button>
              </div>
            </div>
            <button
              className='absolute right-[8px] top-[8px] grid size-6 place-items-center rounded-full bg-gray-50 md:right-[10px] md:top-[10px] md:size-5'
              onClick={onClose}
            >
              <img
                src={CloseIcon}
                alt=''
                width={16}
                height={16}
              />
            </button>
          </div>
        </div>
      )}
    </>,
    document.body,
  );
};
